import { useState, useContext, useEffect } from "react"
import _ from "lodash"
import { gql, useQuery } from "@apollo/client"

import { Field, useFormikContext } from "formik"

import { Dropdown } from "primereact/dropdown"
import { FormContext } from "../../../context/formContext"
import { UserContext } from "../../../context/userContext"

import styles from "../../../styles/Form.module.css"

export default function ManageStaffIdSelector({ field, block, index }) {
  const [staffList, setStaffList] = useState([])
  const [visible, setVisible] = useState("block")
  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }
  const isRequired = checkIfRequired()
  const formik = useFormikContext()
  const form = useContext(FormContext)
  const userCtx = useContext(UserContext)
  useEffect(() => {
    const defaultOption = () => {
      if (
        userCtx.session.user.staff_role >= 2 &&
        userCtx.session.user.staff_role <= 6
      ) {
        return {
          key: userCtx.session.user.staff_id,
          label: `${_.unescape(
            userCtx.session.user.staff_name_first
          )} ${_.unescape(userCtx.session.user.staff_name_last)}`,
        }
      }
      return {}
    }

    return formik.setFieldValue("manage_staff_id_selector", defaultOption())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (block === "participant__manage_services") {
      const manageServicesType = formik?.getFieldProps("manage_services_type")

      setVisible("none")

      if (manageServicesType.value === "Staff assignment") {
        setVisible("block")
      }
    } else {
      setVisible("block")
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik])

  const isDisabled = form ? form.blocksSaved[block] : false

  const GET_STAFF = gql`
    query getStaffList($staff_id: ID!, $organization_id: ID!) {
      staffsByOrganization: staffMembersByOrganization(
        staff_id: $staff_id
        organization_id: $organization_id
      ) {
        staff_id
        staff_name_first
        staff_name_last
      }
    }
  `

  const GET_ASSIGNED_STAFF = gql`
    query getAssignedStaff($participant_id: ID!, $organization_id: ID!) {
      staffsByPid(
        organization_id: $organization_id
        participant_id: $participant_id
      ) {
        staff_id
        staff_name_first
        staff_name_last
      }
    }
  `
  useQuery(GET_ASSIGNED_STAFF, {
    fetchPolicy: "network-only",
    variables: {
      participant_id: userCtx.participant_id,
      organization_id: userCtx.session.user.organization_id,
    },
    skip: !userCtx,
    onCompleted: ({ staffsByPid }) => {
      if (!_.isEmpty(staffsByPid)) {
        const defaultStaff = {
          key: staffsByPid[0].staff_id,
          label: `${_.unescape(staffsByPid[0].staff_name_first)} ${_.unescape(
            staffsByPid[0].staff_name_last
          )}`,
        }
        formik.setFieldValue("manage_staff_id_selector", defaultStaff)
      } else {
        return
      }
      return
    },
  })

  const { loading } = useQuery(GET_STAFF, {
    fetchPolicy: "network-only",
    variables: {
      staff_id: userCtx.session.user.staff_id,
      organization_id: userCtx.session.user.organization_id,
    },
    skip: !userCtx,
    onCompleted: ({ staffsByOrganization }) => {
      const staffs = _.map(staffsByOrganization, (staff) => {
        return {
          label: `${_.unescape(staff.staff_name_first)} ${_.unescape(
            staff.staff_name_last
          )}`,
          key: staff.staff_id,
        }
      })
      const specialStaffs = [
        {
          label: "Unassigned Awaiting",
          key: "-4",
        },
      ]
      const allStaffList = _.concat(staffs, specialStaffs)
      setStaffList(allStaffList)
    },
  })

  if (loading) return null

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: visible,
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && <span className={styles.asterisk}> *</span>}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <Field name={field.field_name}>
        {({ field: formikField, meta }) => (
          <>
            <Dropdown
              placeholder="Please select"
              id={field.field_name}
              name={formikField.name}
              value={formikField.value}
              onChange={formikField.onChange}
              disabled={isDisabled}
              options={staffList}
            />
            {meta.touched && meta.error && (
              <div className={styles.errFieldMsg}>{meta.error}</div>
            )}
          </>
        )}
      </Field>
    </div>
  )
}
